<template>
<el-container class="is-vertical" style="height: 100%; width: 100%; position: fixed;">
  <top-header>
  </top-header>
  <el-container>

    <left-menu/>

    <el-main v-loading="isLoading">
      <el-form r:model="form" label-width="100px">
        <el-form-item label="帳號">
          <el-input :value="$store.state.admin.Username" disabled></el-input>
        </el-form-item>
        <el-form-item label="姓名">
          <el-input v-model="form.Name"></el-input>
        </el-form-item>
        <!-- <el-form-item label="FB權限">
          <div style="margin-left: -80px;">
            <span v-show="$store.getters.adminHasFBAccessToken && $store.getters.adminFBAccessTokenExpired">({{form.FBUserProfileName}}) {{form.FBAccessTokenExpiredAt |moment }}過期 (<span style="color:red">已過期</span>)</span>
            <span v-show="$store.getters.adminHasFBAccessToken && $store.getters.adminFBAccessTokenValid">({{form.FBUserProfileName}}) {{form.FBAccessTokenExpiredAt |moment }}過期 (有效)</span>
            <span v-show="!$store.getters.adminHasFBAccessToken">尚未驗證FB</span>
            <br>
            <el-button @click="onAuthFB">刷新驗證</el-button>
          </div>
        </el-form-item>
        <el-form-item label="FB粉專權限">
          <div style="margin-left: -80px;">
            <span v-show="$store.getters.adminHasFBPageAccessToken && $store.getters.adminFBPageAccessTokenExpired">({{form.FBPageName}}) {{form.FBPageAccessTokenExpiredAt |moment }}過期 (<span style="color:red">已過期</span>)</span>
            <span v-show="$store.getters.adminHasFBPageAccessToken && $store.getters.adminFBAccessTokenValid">({{form.FBPageName}}) {{form.FBPageAccessTokenExpiredAt |moment }}過期 (有效)</span>
            <span v-show="!$store.getters.adminHasFBPageAccessToken">尚未驗證FB</span>
            <br>
            <el-button @click="onAuthFB">刷新驗證</el-button>
          </div>
        </el-form-item>
        <el-form-item label="IG權限">
          <div style="margin-left: -80px;">
            <span v-show="$store.getters.adminHasIGAccessToken && $store.getters.adminIGAccessTokenExpired">({{form.IGUserProfileName}}) {{form.IGAccessTokenExpiredAt |moment }}過期 (<span style="color:red">已過期</span>)</span>
            <span v-show="$store.getters.adminHasIGAccessToken && $store.getters.adminIGAccessTokenValid">({{form.IGUserProfileName}}) {{form.IGAccessTokenExpiredAt |moment }}過期 (有效)</span>
            <span v-show="!$store.getters.adminHasIGAccessToken">尚未驗證IG</span>
            <br>
            <el-button @click="onAuthIG">刷新驗證</el-button>
          </div>
        </el-form-item> -->
        <el-form-item>
          <el-button @click="submit" type="primary">修改名稱</el-button>
        </el-form-item>
        <el-form-item>
          <a @click="isShowPasswordEditor = true">修改密碼?</a>
        </el-form-item>
      </el-form>

      <password-modal :isShow="isShowPasswordEditor" @close="isShowPasswordEditor = false"/>

    </el-main>
  </el-container>
</el-container>
</template>

<script>
import LeftMenu from '@/views/components/LeftMenu.vue'
import TopHeader from '@/views/components/TopHeader.vue'
import PasswordModal from './PasswordModal.vue'

import MixinAuthFB from '@/utils/fb/mixin-auth.vue'
import MixinAuthIG from '@/utils/ig/mixin-auth.vue'
import MixinFilters from '@/utils/filters/filter-mixin.vue'
export default {
  mixins: [MixinFilters, MixinAuthFB, MixinAuthIG],
  components: {
    LeftMenu, TopHeader, PasswordModal
  },
  data () {
    return {
      form: {
        Name: ''
      },
      isLoading: false,
      isShowPasswordEditor: false
    }
  },
  methods: {
    onAuthFB () {
      this.authFB().then(() => {
        this.form = JSON.parse(JSON.stringify(this.$store.state.admin.Profile))
      }).catch(console.error)
    },
    onAuthIG () {
      this.authIG().then(() => {
        this.form = JSON.parse(JSON.stringify(this.$store.state.admin.Profile))
      }).catch(console.error)
    },
    submit () {
      if (!this.validateInput()) { return }
      let payload = {
        Profile: this.form
      }
      this.$services.administrator.updateMe(this, payload).then((res) => {
        let ok = res && res.data && res.data.status === 'ok'
        if (ok) this.onOK()
      }).catch(this.$handleServiceError)
    },
    onOK () {
      this.$message({
        message: `修改成功`,
        type: 'success'
      })
      this.form = JSON.parse(JSON.stringify(this.$store.state.admin.Profile))
    },
    validateInput () {
      var errMsg = null
      if (!this.form.Name) {
        errMsg = '請輸入姓名'
      }
      // 時間..
      if (errMsg) {
        this.$alert(errMsg, '錯誤', {
          confirmButtonText: '確認',
          type: 'error'
        })
      }
      return errMsg === null
    }
  },
  created () {
    this.form = JSON.parse(JSON.stringify(this.$store.state.admin.Profile))
  }
}
</script>

<style>
a {
  color: gray;
  text-decoration: underline;
  cursor: pointer;
}
</style>
